'use client';

import React from 'react';
import { Grid } from '@mui/material';
import Slider from './Slider';
import { useIsMobile } from '@/ui/kit/utils/useIsMobile';
interface ListItemsProps<T> {
  items: T[];
  id: string;
  customComponent: (item: T, index: number) => React.ReactNode;
}
function ListItems<T>(props: ListItemsProps<T>) {
  const isMobile = useIsMobile();
  const {
    items,
    customComponent,
    id
  } = props;
  return <Grid rowSpacing={'var(--spacing_m)'} columnSpacing={{
    xs: 'var(--spacing_m)',
    md: 'var(--spacing_m)'
  }} sx={{
    '& .swiper-slide': {
      width: items.length > 1 ? '90%' : '100%'
    }
  }} container data-sentry-element="Grid" data-sentry-component="ListItems" data-sentry-source-file="ListItems.tsx">
      {isMobile ? <Slider<T> data={items} allowTouchMove={true} customComponent={(item, idx) => <Grid size={{
      md: 6,
      xs: 12
    }} key={id + idx}>
              {customComponent(item, idx)}
            </Grid>} /> : items.map((item, idx) => {
      return <Grid size={{
        md: 6,
        xs: 12
      }} key={id + idx}>
              {customComponent(item, idx)}
            </Grid>;
    })}
      {}
    </Grid>;
}
export default ListItems;